import React, { useState } from "react";
import ActionButton, { ActionButtonProps } from "../../Actions/ActionButton";
import { caseRelatedActions, caseRelatedAdditionalActions } from "../../../services/navigationActionsService";
import CaseRelatedOverlays from "./CaseRelatedOverlays";
import CaseRelatedContainer from "./CaseRelatedContainer";
import { queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { useQueryClient } from "@tanstack/react-query";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { useCase } from "../../../provider/CaseProvider";
import { useCall } from "../../../provider/CallProvider";
import { useInquiry } from "../../../hooks/useInquiry";
import { useDrawer } from "../../../provider/DrawerProvider";

const CaseRelatedActions = () => {
  const currentUser = useCurrentUser();
  const [open, setOpen] = useState("");
  const [useCondensedView, setUseCondensedView] = useState(false);
  const queryClient = useQueryClient();
  const { product, refreshCase } = useCase();
  const { call, callModalOpen, openCallModal } = useCall();
  const { setDrawerState } = useDrawer();

  const { inquiryToCustomerCollection, refreshInquiryToCustomerCollection } = useInquiry(product);

  if (!product || !inquiryToCustomerCollection) {
    return null;
  }

  const Actions = ({ actions }: { actions: ActionButtonProps[] }) => {
    return (
      <>
        {actions.map((actionProps, index) => (
          <ActionButton key={index} useCondensedView={useCondensedView} {...actionProps} />
        ))}
      </>
    );
  };

  const refreshActivities = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.collections("activities")
    });
  };

  const refreshPage = () => {
    refreshCase();
    refreshInquiryToCustomerCollection();
  };

  return (
    <div>
      <CaseRelatedContainer
        mainActions={
          <Actions
            actions={caseRelatedActions(
              product,
              setOpen,
              setDrawerState,
              currentUser,
              call !== null,
              callModalOpen,
              openCallModal
            )}
          />
        }
        moreActions={
          <Actions
            actions={caseRelatedAdditionalActions(
              product,
              setOpen,
              inquiryToCustomerCollection,
              currentUser
            )}
          />
        }
        useCondensedView={useCondensedView}
        setUseCondensedView={setUseCondensedView}
      />
      <CaseRelatedOverlays
        product={product}
        open={open}
        setOpen={setOpen}
        refreshPage={refreshPage}
        refreshActivities={refreshActivities}
      />
    </div>
  );
};

export default CaseRelatedActions;
